import { WorkoutModifyModal } from './WorkoutModifyModal';

export default WorkoutModifyModal;
